<template>
  <div class="page" id="page-auth">
    <div class="container">
  <div class="element-auth">
    <main>
      <div class="body">
        <template v-if="currentStep == 'login'">
          <ul>
            <li><div class="title">로그인</div></li>

            <li><element-textbox v-model="formData.steps[0].name.value" :label="formData.steps[0].name.label" :error="formData.steps[0].name.error" :placeholder="formData.steps[0].name.placeholder"/></li>
            <li><element-certification @certification="certification" v-model="formData.steps[0].phone.value" :label="formData.steps[0].phone.label" :error="formData.steps[0].phone.error" :placeholder="formData.steps[0].phone.placeholder"/></li>
            <li v-if="statusCertification"><element-textbox v-model="formData.steps[0].certification.value" :label="formData.steps[0].certification.label" :error="formData.steps[0].certification.error" :placeholder="formData.steps[0].certification.placeholder" /></li>
          </ul>
        </template>

        <template v-if="currentStep == 'signup'">
          <ul>
            <li><div class="title">회원가입</div></li>

            <li><element-textbox v-model="formData.steps[1].name.value" :label="formData.steps[1].name.label" :error="formData.steps[1].name.error" :placeholder="formData.steps[1].name.placeholder"/></li>
            <li>
              <element-textbox v-model="formData.steps[1].birthNumber.value" :label="formData.steps[1].birthNumber.label" :error="formData.steps[1].birthNumber.error" :placeholder="formData.steps[1].birthNumber.placeholder"/>
            </li>
            <li>
              <element-textbox v-model="formData.steps[1].email.value" :label="formData.steps[1].email.label" :error="formData.steps[1].email.error" :placeholder="formData.steps[1].email.placeholder"/>
            </li>
            <li><element-certification @certification="certification" v-model="formData.steps[1].phone.value" :label="formData.steps[1].phone.label" :error="formData.steps[1].phone.error" :placeholder="formData.steps[1].phone.placeholder"/></li>
            <li v-if="statusCertification"><element-textbox v-model="formData.steps[1].certification.value" :label="formData.steps[1].certification.label" :error="formData.steps[1].certification.error" :placeholder="formData.steps[1].certification.placeholder" /></li>
          </ul>
        </template>
      </div>
    </main>
    <footer>
      <div class="terms">
        <template v-if="currentStep == 'signup'">
          <element-checkbox-have-detail v-model="formData.steps[1].terms.value" :label="formData.steps[1].terms.label" :error="formData.steps[1].terms.error" />
        </template>
      </div>

      <div class="buttons">
        <template v-if="currentStep == 'login'">
          <button id="on" @click="validate(1, 'info')">로그인</button>
          아직 인슈넷FC 회원이 아니십니까?<br/>
          입력한 정보를 바탕으로 간편하게 회원가입하세요.
          <button @click="currentStep = 'signup'">회원가입</button>
        </template>

        <template v-if="currentStep == 'signup'">
          <button id="on" @click="validate(2, 'info')">회원가입</button>
          <button @click="currentStep = 'login'">로그인으로 돌아가기</button>
        </template>
      </div>
    </footer>
  </div>
</div>
</div>
</template>
<script>

export default {
  props: [ "data" ],
  data(){
    return {
      availableNext: false,
      currentStep: 'login',
      statusCertification: false,
      certificationCode: "",
      formData: {
        steps: [
          {
            title: "로그인",
            value: "",
            name: {
              label: "이름",
              error: "",
              value: "",
              placeholder: "이름",
              validations: [
                { type: "required", message: "필수항목입니다" }
              ]
            },
            phone: {
              label: "휴대폰 번호",
              error: "",
              value: "",
              placeholder: "- 없이 입력",
              validations: [
                { type: "certification", message: "인증번호를 입력하셔야합니다" },
                { type: "required", message: "필수항목입니다" }
              ]
            },
            certification: {
              label: "인증번호",
              value: "",
              error: "",
              validations: [
                { type: "check", message: "인증번호가 일치하지 않습니다" },
                { type: "required", message: "필수항목입니다" }
              ]
            }
          },
          {
            title: "회원가입",
            name: {
              label: "이름",
              error: "",
              value: "",
              placeholder: "이름",
              validations: [
                { type: "required", message: "필수항목입니다" }
              ]
            },
            phone: {
              label: "휴대폰 번호",
              error: "",
              value: "",
              placeholder: "- 없이 입력",
              validations: [
                { type: "certification", message: "인증번호를 입력하셔야합니다" },
                { type: "required", message: "필수항목입니다" }
              ]
            },
            email: {
              label: "이메일",
              error: "",
              value: "",
              placeholder: "이메일 주소 입력",
              validations: [
                { type: "required", message: "필수항목입니다" }
              ]
            },
            birthNumber: {
              label: "생년월일",
              error: "",
              value: "",
              placeholder: "앞 6자리 입력",
              validations: [
                { type: "birth", message: "필수항목입니다" },
                { type: "required", message: "필수항목입니다" }
              ]
            },
            terms: {
              label: "약관",
              error: "",
              value: [
                { label: "개인정보 수집 및 회원 약관 동의(필수)", value: false },
                /*{ label: "인슈넷FC 회원 약관 동의(필수)", value: false }*/
              ],
              validations: [
                { type: "terms-required", message: "필수항목입니다" },
              ]
            },
            certification: {
              label: "인증번호",
              value: "",
              error: "",
              validations: [
                { type: "check", message: "인증번호가 일치하지 않습니다" },
                { type: "required", message: "필수항목입니다" }
              ]
            }
          },
          {
            title: "가입자",
            name: {
              label: "이름",
              error: "",
              value: "",
              placeholder: "이름"
            },
            phone: {
              label: "휴대폰 번호",
              error: "",
              value: "",
              placeholder: "- 없이 입력"
            },
            email: {
              label: "이메일",
              error: "",
              value: "",
              placeholder: "이메일 주소 입력"
            },
            birthNumber: {
              label: "주민번호",
              error: "",
              value: [
                { value: "" },
                { value: "" }
              ],
              placeholder: [
                { value: "앞 6자리 입력" },
                { value: "뒷 7자리 입력" }
              ]
            },
          },
        ]
      }
    }
  },
  mounted() {
    this.$watch( "formData.steps", ( newData, oldData ) => {
      if( newData ){
        if(this.currentStep == "login"){
          Object.values( this.formData.steps[0] ).forEach( o => {
          if(!this.checkValidation( o, false )) this.$parent.$parent //.forceBlockNextStep()
        });
        }else if(this.currentStep == "signup"){
          Object.values( this.formData.steps[1] ).forEach( o => {
          if(!this.checkValidation( o, false ))  this.$parent.$parent //.forceBlockNextStep()
        });
        }else if(this.currentStep == "info"){
          Object.values( this.formData.steps[2] ).forEach( o => {
            if(!this.checkValidation( o, false )) {
            }
          });
        }

      };
    }, { immediate: true, deep: true });
  },
  created(){
    this.setUserData();

    if(this.$store.state.customer.profile){
      this.currentStep = 'login'
    }
    else if(this.$route.query.tab === '고객정보관리'){
      this.currentStep = 'info';
    }
  },
  methods: {
    setUserData: function() {
      let token = localStorage.eleToken;

      let profile = this.$store.state.customer.profile;



      if(token && profile._id){


        let extra = profile ? JSON.parse(profile.customer_extra) : null;

        this.$router.replace({ name: "MyInsurance" });
      }
    },
    certification: function( value ) {
      this.statusCertification = value.check;
      this.certificationCode = Math.floor(Math.random()*(999999-100000+1)) + 100000;
      this.$store.dispatch( "customer/getCertification", { data: value.value, code: this.certificationCode } );
    },
    validate( current, value ) {

      if(current == 1){
        if(this.validateField(current-1)){
          this.$store.dispatch( "customer/getAuth", { phone: this.formData.steps[0].phone.value, name: this.formData.steps[0].name.value } ).then(res => {
            if(res.data.status !== 'error'){
              this.setUserData();
              this.currentStep = value;
            }
            else{
              this.$store.commit( "elementSnackbar/SET_ITEM", { message: "이름 또는 핸드폰 번호가 올바르지 않습니다.", status: "false" });
            }
          });

        }
      }
      else{
        if(this.validateField(current-1)){
          this.$store.dispatch( "customer/regist", {
            customer_name: this.formData.steps[1].name.value,
            customer_social_number: this.formData.steps[1].birthNumber.value,
            customer_email: this.formData.steps[1].email.value,
            phone: this.formData.steps[1].phone.value } ).then(res => {

            if(res.data.status !== 'error'){
              this.setUserData();
              this.currentStep = value;

              // 회원정보를 crm_customer 에 등록 후 customer_id 와 phone 정보를 crm_customer_phone에 저장
              this.$store.dispatch( "customer/registPhone", {phone: this.formData.steps[1].phone.value, customerid: res.data.data._id } ).then(res => {
                if(res.data.status !== 'error'){
                  //this.setUserData();
                  //this.currentStep = value;
                }
                else{
                  this.$store.commit( "elementSnackbar/SET_ITEM", { message: "ERROR OCCURED", status: "false" } );
                }
              });

            }
            else{
              this.$store.commit( "elementSnackbar/SET_ITEM", { message: res.data.error, status: "false" });
            }
          });
        }
      }
    },
    isEmpty(value) {
      return ( value === undefined
        || value === null
        || (typeof value === 'object' && Object.keys(value).length === 0)
        || (typeof value === 'string' && value.trim().length === 0)
      )
    },
    validateField( index, setError = true ){
      var result = true;
      Object.values( this.formData.steps[index] ).forEach( o => {
        if( !this.checkValidation( o, setError ) ) {

          result = false;
        }
      });

      return result;
    },
    checkValidation( ob, setError ){
      if( !ob.validations ) return true;
      var result = null;
      var vm = this;
      ob.validations.forEach( o => {
        if( o.type.split( ":" ).length > 1 ){
          var vn = o.type.split( ":" )[0];
          var vv = o.type.split( ":" )[1];
          switch( vn ){
            case "min" :
              if( ob.value.length < vv ){
                result = o.message;
              };
            break;
            case "max" :
              if( ob.value.length > vv ){
                result = o.message;
              };
            break;
            case "matchField" :
              if( ob.value != this.formData[vv].value ){
                result = o.message;
              };
            break;
            case "matchString" :
              if( ob.value != vv ){
                result = o.message;
              };
            break;
          };
        }else{
          var vn = o.type;
          switch( vn ){
            case "email" :
              var regExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
              if( !regExp.test( ob.value ) ){
                result = o.message;
              };
            break;
            case "required" :
              if( typeof ob.value != "number" && !ob.value ){
                result = o.message;
              };
            break;
            case "number" :
              var regExp = /^[0-9]*$/;
              if( !regExp.test( ob.value ) ){
                result = o.message;
              };
            break;
            case "birth" :
              //6자리만 입력되도로 정규화
              if (ob.value.length>6 ) {
                ob.value = ob.value.substr(0,6)
              }
              //숫자 입력되로고 정규화 추가
              var regNumber = /^[0-9]*$/;
              if (!regNumber.test(ob.value)) {
                ob.value = "";
              }
              var regExp = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))$/;
              if( !regExp.test( ob.value ) ){
                result = o.message;
              }
              break;
            case "certification" :
              if(!this.statuscertification && ((this.currentStep === 'login' && !this.formData.steps[0].certification.value ) || (this.currentStep === 'signup' && !this.formData.steps[1].certification.value ))) {
                result = o.message;
              }
            break;
            case "birth-required" :
              if( typeof ob.value[0].value != "number" && !ob.value[0].value && typeof ob.value[1].value != "number" && !ob.value[1].value ){
                result = o.message;
              }
            break;
            case "terms-required" :
              if( !ob.value[0].value){ // || !ob.value[1].value
                result = o.message;
              }
            break;
            case "check" :
              if( ob.value != vm.certificationCode ){
                result = o.message;
              }
            break;
          };
        }
      });
      if( result ){
        if( setError ) ob.error = result;
        return false;
      }else{
        if( setError ) ob.error = null;
        return true;
      };
    }
  }
}
</script>
